<template>
  <BaseFormFieldLayout
    :id="id"
    :label="label"
    :note="note"
    :error-message="errorMessage"
    :field-class="fieldClass"
  >
    <textarea
      :id="id"
      ref="textarea"
      :value="model"
      v-bind="$attrs"
      class="form-control"
      :class="{ 'is-invalid': errorMessage, 'no-resize': noResize }"
      @input="handleInput"
    ></textarea>
  </BaseFormFieldLayout>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue'

const model = defineModel<string>()
const textarea = ref<HTMLTextAreaElement | null>(null)
const initialResizeDone = ref(false)

const props = defineProps({
  id: {
    type: [String || Number],
    required: true,
  },
  label: {
    type: String,
    default: '',
  },
  note: {
    type: String,
    default: '',
  },
  errorMessage: {
    type: String,
    default: '',
  },
  fieldClass: {
    type: String,
    default: '',
  },
  autosize: {
    type: Boolean,
    default: false,
  },
  noResize: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits<{
  (e: 'input', value: string | unknown): void
}>()

const handleInput = (e: Event) => {
  const target = e.target as HTMLTextAreaElement
  model.value = target.value
  emit('input', model.value)
  if (props.autosize) {
    handleAutoResize(target)
  }
}

const handleAutoResize = (element: HTMLTextAreaElement) => {
  element.style.height = ''
  element.style.height = element.scrollHeight + 'px'

  if (!initialResizeDone.value) initialResizeDone.value = true
}

const resizeOnInit = (element: HTMLTextAreaElement) => {
  if (element.scrollHeight === 0 && !initialResizeDone.value) {
    setTimeout(() => {
      resizeOnInit(element)
    }, 30)
  } else {
    handleAutoResize(element)
  }
}

onMounted(() => {
  if (props.autosize) {
    if (textarea.value) {
      resizeOnInit(textarea.value)
    }
  }
})
</script>

<style lang="scss" scoped>
.no-resize {
  resize: none;
}
</style>